<span *permissions="[pc.names.AccountsManageHierarchy, pc.privilege.Delete]" style="cursor: pointer">
  <i class="fa fa-trash-alt fa-2x" (click)="deleteClicked.emit(data.id)"></i>
</span>
